import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link, useNavigate } from "react-router-dom";
import greencal from "../../images/greencal.png";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import {
  getInvoiceById,
  getCreatePastOrder,
} from "../../../service/Invoice/InvoiceService";
import { getAllPastOrderDetailsList } from "../../../service/PastOrder/PastOrderService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SpinnerComponent from "../../components/SpinnerComponent";
import { currencyToLocale } from "./Invoice";
import { getAllCurrencylist } from "../../../service/Currency/CurrencyService";
import countryLocales from "./Locale";
import { useTranslation } from "react-i18next";

const Invoicedetails = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [allPastOrderList, setAllPastOrderList] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const invoiceId = new URLSearchParams(location.search);
  // console.log(invoiceId.get(`id`), "invoiceId")
  const [isActive, setActive] = useState("false");
  const handleToggle = () => {
    setActive(!isActive);
  };

  const [isShow, setIsShow] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const showToggle = () => {
    setIsShow(!isShow);
  };
  const showhide = isShow ? "showfield" : "hidefield";
  const [getInvoiceId, setInvoiceId] = useState([]);

  useEffect(() => {
    getallInvoiceList();
    getCurrencyDataList();
  }, []);

  async function getallInvoiceList() {
    setIsLoading(true);
    getInvoiceById(invoiceId.get(`id`)).then(function (result) {
      const response = result.data;
      //  console.log(response, "response");
      setInvoiceId(response?.data?.InvoiceDetails);
      setIsLoading(false);
      // setDepartmentId(response?.data?.businessUnit?.Departments);
    });
  }

  async function getAllPastOrderDetailsList1() {
    setIsLoading(true);
    getAllPastOrderDetailsList().then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr")
      setAllPastOrderList(response?.data?.listPastOrder);
      setIsLoading(false);
    });
  }

  useEffect(() => {
    getAllPastOrderDetailsList1();
  }, []);
  async function getCurrencyDataList() {
    getAllCurrencylist().then(function (result) {
      // console.log(result?.data, "datadatadatadatada")
      const response = result?.data;

      const defaultCurrencyData = response?.data?.currencyList.filter(
        (item) => item.defaultCurrency
      );
      setCurrencyData(defaultCurrencyData);
      //  console.log("defaultCurrencyData", defaultCurrencyData);
    });
  }

  const onPastOrder = (e) => {
    setIsLoading(true);
    //  console.log([invoiceId.get(`id`)], "pastpast");
    getCreatePastOrder([Number(invoiceId.get(`id`))], (r) => {
      //  console.log(r, "response");
      if (r.success === true) {
        setIsLoading(false);
        toast.success(r.message);
        navigate("/invoice");
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const formatCurrency = (amount, currency = "USD") => {
    const selectedLocale = countryLocales.find(
      (item) => item.country === currency
    )?.code;

    return new Intl.NumberFormat(selectedLocale, {
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <div className="container-fluid">
      <div className="dbMain invoice">
        <Leftpanel />
        <div className="dbRight">
          <Header link="/invoice" title={t("Invoice Details")} description="" />
          <div className="commonBase">
            {isLoading && <SpinnerComponent isLoading={isLoading} />}

            <div className="row">
              <div className="col-md-6 mb-4">
                <h5>
                  {getInvoiceId?.invoice?.Invoice?.AccountingSupplierParty
                    ?.Party?.PartyName?.Name?._text || ""}
                </h5>
                <div className="vnTop">
                  <div>
                    <div>
                      {getInvoiceId?.invoice?.Invoice?.AccountingSupplierParty
                        ?.Party?.PostalAddress?.StreetName?._text || ""}
                    </div>
                    <div>
                      {getInvoiceId?.invoice?.Invoice?.AccountingSupplierParty
                        ?.Party?.PostalAddress?.CityName?._text || ""}
                    </div>
                    <div>
                      {getInvoiceId?.invoice?.Invoice?.AccountingSupplierParty
                        ?.Party?.PostalAddress?.PostalZone?._text || ""}
                      {getInvoiceId?.invoice?.Invoice?.AccountingSupplierParty
                        ?.Party?.PostalAddress?.Country?.IdentificationCode
                        ?._text || ""}
                    </div>
                  </div>
                  <div>
                    <div>
                      Telephone -{" "}
                      {getInvoiceId?.invoice?.Invoice?.AccountingSupplierParty
                        ?.Party?.Contact?.Telephone?._text || ""}
                    </div>
                    <div>
                      VAT no: -{" "}
                      {getInvoiceId?.invoice?.Invoice?.AccountingSupplierParty
                        ?.Party?.PartyTaxScheme?.CompanyID?._text || ""}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-4 ps-md-5 pt-3">
                <h5 className="pb-1">{t("Invoice")}</h5>
                <div className="vnTop">
                  <h6>
                    {t("Invoice No")} -{" "}
                    {getInvoiceId?.invoice?.Invoice?.ID?._text || ""}
                  </h6>

                  <h6>
                    {t("Viridi Order Id")} -{" "}
                    <Link
                      to={`/pastorderedit?id=${getInvoiceId?.PastOrderDetails?.id}&invoiceId=${getInvoiceId?.PastOrderDetails?.invoiceId}`}
                      style={{ color: "rgb(13, 110, 253)" }}
                    >
                      {getInvoiceId?.PastOrderDetails?.id}
                    </Link>
                  </h6>
                  {getInvoiceId?.isCreated ? (
                    ""
                  ) : (
                    <button className="commonButton" onClick={onPastOrder}>
                      {t("Create Past Order")}
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="purchaser">
                  <strong>
                    <small>{t("Purchaser")}</small>
                  </strong>
                  <h5>
                    {getInvoiceId?.invoice?.Invoice?.AccountingCustomerParty
                      ?.Party?.PartyName?.Name?._text || ""}
                  </h5>
                  <div>
                    {getInvoiceId?.invoice?.Invoice?.AccountingCustomerParty
                      ?.Party?.PostalAddress?.AdditionalStreetName?._text || ""}
                  </div>
                  <div>
                    {getInvoiceId?.invoice?.Invoice?.AccountingCustomerParty
                      ?.Party?.PostalAddress?.StreetName?._text || ""}
                  </div>
                  <div>
                    {getInvoiceId?.invoice?.Invoice?.AccountingCustomerParty
                      ?.Party?.PostalAddress?.CityName?._text || ""}
                  </div>
                  <div>
                    {getInvoiceId?.invoice?.Invoice?.AccountingCustomerParty
                      ?.Party?.PostalAddress?.PostalZone?._text || ""}
                    {getInvoiceId?.invoice?.Invoice?.AccountingSupplierParty
                      ?.Party?.PostalAddress?.Country?.IdentificationCode
                      ?._text || ""}
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="purchaser">
                  <strong>
                    <small>{t("date_of_payment")}</small>
                  </strong>
                  <p>
                    <img src={greencal} alt="" />{" "}
                    {getInvoiceId?.invoice?.Invoice?.IssueDate?._text || ""}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="purchaser mb-2">
                  <strong>
                    <small>{t("last_date_of_payment")}</small>
                  </strong>
                  <p>
                    <img src={greencal} alt="" />{" "}
                    {getInvoiceId?.invoice?.Invoice?.InvoicePeriod?.EndDate
                      ?._text || ""}
                  </p>
                </div>
                <div className="purchaser mb-1">
                  <strong>
                    <small>{t("For payment")}</small>
                  </strong>
                  <h4>
                    {currencyData[0]?.name} &nbsp;
                    {formatCurrency(
                      Number(
                        getInvoiceId?.invoice?.Invoice?.LegalMonetaryTotal
                          ?.PayableAmount?._text || 0
                      ),
                      currencyData[0]?.name
                    )}
                  </h4>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="paymentInfo">
                  <h5 className="mb-0">{t("Payment information")}</h5>
                  {/* <button className='commonButton'>{t("Not available")}</button> */}
                </div>
                <div className="paymentInfo accinftable">
                  <h6>
                    {t("Listing")}: {getInvoiceId?.invoice?.Invoice?.ID?._text}
                  </h6>
                  <div className="accInf">
                    <div className="accInfinn">
                      <div className="accincl">
                        {t("Accounting information")}
                      </div>
                      <div className="accincl">-&nbsp;</div>
                      <div className="accincl">
                        <span>
                          {
                            getInvoiceId?.invoice?.Invoice
                              ?.AccountingSupplierParty?.Party?.PartyName?.Name
                              ?._text
                          }
                        </span>
                      </div>
                    </div>
                    <div className="accInfinn">
                      <div className="accincl">{t("Business account")}</div>
                      <div className="accincl">-&nbsp;</div>
                      <div className="accincl">
                        <span>
                          {
                            getInvoiceId?.invoice?.Invoice
                              ?.AccountingSupplierParty?.Party?.PartyLegalEntity
                              ?.CompanyID?._text
                          }
                        </span>
                      </div>
                    </div>
                    <div className="accInfinn">
                      <div className="accincl">{t("Purchase Order no:")}</div>
                      <div className="accincl">-&nbsp;</div>
                      <div className="accincl">
                        <span>
                          {
                            getInvoiceId?.invoice?.Invoice?.OrderReference?.ID
                              ?._text
                          }
                        </span>
                      </div>
                    </div>
                    <div className="accInfinn">
                      <div className="accincl">{t("Delivery date")}</div>
                      <div className="accincl">-&nbsp;</div>
                      <div className="accincl">
                        <span>
                          {getInvoiceId?.invoice?.Invoice?.IssueDate?._text}
                        </span>
                      </div>
                    </div>
                    <div className="accInfinn">
                      <div className="accincl">{t("Payment terms")}</div>
                      <div className="accincl">-&nbsp;</div>
                      <div className="accincl">
                        <span>
                          {
                            getInvoiceId?.invoice?.Invoice?.PaymentTerms?.Note
                              ?._text
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-4">&nbsp;</div>
            </div>

            <div className="respScrl1">
              <div className="accInf productTable">
                <div className="accInfinn accINfHdn">
                  <div className="accincl">{t("Product no.")}</div>
                  <div className="accincl">{t("Description")}</div>
                  <div className="accincl">{t("Qty")}</div>
                  <div className="accincl">{t("Unit")}</div>
                  <div className="accincl">{t("Price")}</div>
                  <div className="accincl">{t("VAT")}</div>
                  <div className="accincl">{t("Discount")}</div>
                  <div className="accincl">{t("Amount")}</div>
                  <div className="accincl">
                    <div>{t("Amount")}</div>
                    <small>({t("With VAT")})</small>
                  </div>
                </div>
                {!Array.isArray(getInvoiceId?.invoice?.Invoice?.InvoiceLine) &&
                  [getInvoiceId?.invoice?.Invoice?.InvoiceLine]?.map(
                    (d, index) => (
                      <div className="accInfinn" key={`single-${index}`}>
                        <div className="accincl">
                          {d?.Item?.SellersItemIdentification?.ID?._text}
                        </div>
                        <div className="accincl">{d?.Item?.Name?._text}</div>
                        <div className="accincl">
                          {d?.InvoicedQuantity?._text}
                        </div>
                        <div className="accincl">
                          {d?.InvoicedQuantity?._attributes?.unitCode}
                        </div>
                        <div className="accincl">
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(d?.Price?.PriceAmount?._text),
                            currencyData[0]?.name
                          )}
                        </div>
                        <div className="accincl">
                          {d?.Item?.ClassifiedTaxCategory?.ID?._text}
                        </div>
                        <div className="accincl">---{d?.Item?.ID?._text}</div>
                        <div className="accincl">
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(d?.LineExtensionAmount?._text),
                            currencyData[0]?.name
                          )}
                        </div>
                        <div className="accincl">
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(
                              (
                                (Number(d?.LineExtensionAmount?._text) *
                                  Number(
                                    d?.Item?.ClassifiedTaxCategory?.Percent
                                      ?._text
                                      ? d?.Item?.ClassifiedTaxCategory?.Percent
                                          ?._text
                                      : 0
                                  )) /
                                  100 +
                                Number(d?.LineExtensionAmount?._text)
                              ).toFixed(2)
                            ),
                            currencyData[0]?.name
                          )}
                        </div>
                      </div>
                    )
                  )}
                {Array.isArray(getInvoiceId?.invoice?.Invoice?.InvoiceLine) &&
                  getInvoiceId?.invoice?.Invoice?.InvoiceLine?.map(
                    (d, index) => (
                      <div className="accInfinn" key={`array-${index}`}>
                        <div className="accincl">
                          {d?.Item?.SellersItemIdentification?.ID?._text}
                        </div>
                        <div className="accincl">{d?.Item?.Name?._text}</div>
                        <div className="accincl">
                          {d?.InvoicedQuantity?._text}
                        </div>
                        <div className="accincl">
                          {d?.InvoicedQuantity?._attributes?.unitCode}
                        </div>
                        <div className="accincl">
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(d?.Price?.PriceAmount?._text),
                            currencyData[0]?.name
                          )}
                        </div>
                        <div className="accincl">
                          {d?.Item?.ClassifiedTaxCategory?.ID?._text}
                        </div>
                        <div className="accincl">---{d?.Item?.ID?._text}</div>
                        <div className="accincl">
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(d?.LineExtensionAmount?._text),
                            currencyData[0]?.name
                          )}
                        </div>
                        <div className="accincl">
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(
                              (
                                (Number(d?.LineExtensionAmount?._text) *
                                  Number(
                                    d?.Item?.ClassifiedTaxCategory?.Percent
                                      ?._text
                                      ? d?.Item?.ClassifiedTaxCategory?.Percent
                                          ?._text
                                      : 0
                                  )) /
                                  100 +
                                Number(d?.LineExtensionAmount?._text)
                              ).toFixed(2)
                            ),
                            currencyData[0]?.name
                          )}
                        </div>
                      </div>
                    )
                  )}
              </div>

              <div className="invTablegroup">
                <table>
                  <tbody>
                    <tr>
                      <td colSpan="5">
                        <table className="invt2">
                          <tbody>
                            <tr>
                              <th>{t("Summary of VAT")}</th>
                              <th>{t("Taxable amount")}</th>
                              <th>{t("Tax")}</th>
                            </tr>

                            {[
                              ...(Array.isArray(
                                getInvoiceId?.invoice?.Invoice?.TaxTotal
                                  ?.TaxSubtotal
                              )
                                ? getInvoiceId.invoice.Invoice.TaxTotal
                                    .TaxSubtotal
                                : [
                                    getInvoiceId?.invoice?.Invoice?.TaxTotal
                                      ?.TaxSubtotal,
                                  ]),
                            ]?.map((taxItem, index) => (
                              <tr key={index}>
                                <td>
                                  {taxItem?.TaxCategory?.ID?._text || ""}
                                  {` (${formatCurrency(
                                        Number(
                                          taxItem
                                            ?.TaxCategory
                                            ?.Percent
                                            ?._text ||
                                            0
                                        ),
                                        currencyData[0]
                                          ?.name
                                      )}
                                    %)`}
                                </td>
                                {/* <td>
                                  {formatCurrency(
                                    Number(
                                      taxItem?.TaxCategory?.Percent?._text || 0
                                    ),
                                    currencyData[0]?.name
                                  )}
                                  %
                                </td> */}
                                <td>
                                  {currencyData[0]?.name && (
                                    <>
                                      {currencyData[0]?.name} &nbsp;
                                      {formatCurrency(
                                        Number(
                                          taxItem?.TaxableAmount?._text || 0
                                        ),
                                        currencyData[0]?.name
                                      )}
                                    </>
                                  )}
                                </td>
                                <td>
                                  {currencyData[0]?.name && (
                                    <>
                                      {currencyData[0]?.name} &nbsp;
                                      {formatCurrency(
                                        Number(taxItem?.TaxAmount?._text || 0),
                                        currencyData[0]?.name
                                      )}
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))}

                            {/* Total Row */}
                            <tr>
                              <td colSpan="2" className="fw-bold text-end">
                                Total VAT:
                              </td>
                              <td className="fw-bold">
                                {currencyData[0]?.name} &nbsp;
                                {formatCurrency(
                                  (Array.isArray(
                                    getInvoiceId?.invoice?.Invoice?.TaxTotal
                                      ?.TaxSubtotal
                                  )
                                    ? getInvoiceId.invoice.Invoice.TaxTotal
                                        .TaxSubtotal
                                    : [
                                        getInvoiceId?.invoice?.Invoice?.TaxTotal
                                          ?.TaxSubtotal,
                                      ]
                                  )?.reduce((acc, curr) => {
                                    const amount = Number(
                                      curr?.TaxAmount?._text || 0
                                    );
                                    return acc + amount;
                                  }, 0),
                                  currencyData[0]?.name
                                )}
                              </td>
                            </tr>

                            {/* <tr>
                              <td>
                                {getInvoiceId?.invoice?.Invoice?.TaxTotal
                                  ?.TaxSubtotal?.TaxCategory?.ID?._text || ""}
                              </td>
                              <td>
                                {formatCurrency(
                                  Number(
                                    getInvoiceId?.invoice?.Invoice?.TaxTotal
                                      ?.TaxSubtotal?.TaxCategory?.Percent
                                      ?._text || 0
                                  ),
                                  currencyData[0]?.name
                                )}
                                %
                              </td>
                              <td>
                                {currencyData[0]?.name && (
                                  <>
                                    {currencyData[0]?.name} &nbsp;
                                    {formatCurrency(
                                      Number(
                                        getInvoiceId?.invoice?.Invoice?.TaxTotal
                                          ?.TaxSubtotal?.TaxableAmount?._text ||
                                          0
                                      ),
                                      currencyData[0]?.name
                                    )}
                                  </>
                                )}
                              </td>
                              <td>
                                {currencyData[0]?.name && (
                                  <>
                                    {currencyData[0]?.name} &nbsp;
                                    {formatCurrency(
                                      Number(
                                        getInvoiceId?.invoice?.Invoice?.TaxTotal
                                          ?.TaxSubtotal?.TaxAmount?._text || 0
                                      ),
                                      currencyData[0]?.name
                                    )}
                                  </>
                                )}
                              </td>
                            </tr> */}

                            {/* <tr>
                              <td colSpan="3">
                                <strong>{t("Total VAT")}:</strong>
                              </td>
                              <td>
                                <strong>
                                  {formatCurrency(
                                    Number(
                                      getInvoiceId?.invoice?.Invoice?.TaxTotal
                                        ?.TaxSubtotal?.TaxAmount?._text || 0
                                    ),
                                    currencyData[0]?.name
                                  )}
                                </strong>
                              </td>
                            </tr> */}
                          </tbody>
                        </table>
                      </td>

                      <td colSpan="3" className="text-end ttend">
                        <div>{t("Total")}</div>
                        <div>{t("total_fees")}</div>
                        <div>{t("total_discount")}</div>
                        <div>{t("Total VAT")}</div>
                        <div>{t("total_rounding")}</div>
                        <div className="bdrs"></div>
                        <h6>{t("Total of Invoice")}</h6>
                        <div>{t("Prepaid")}</div>
                        <div className="bdrs"></div>
                        <h6>{t("Total for payment")}</h6>
                      </td>
                      <td colSpan="2">
                        <div>
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(
                              getInvoiceId?.invoice?.Invoice?.LegalMonetaryTotal
                                ?.LineExtensionAmount?._text || 0
                            ),
                            currencyData[0]?.name
                          )}
                        </div>
                        <div>
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(
                              getInvoiceId?.invoice?.Invoice?.LegalMonetaryTotal
                                ?.PrepaidAmount?._text || 0
                            ),
                            currencyData[0]?.name
                          )}
                        </div>
                        <div>--</div>
                        <div>
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(
                              getInvoiceId?.invoice?.Invoice?.TaxTotal
                                ?.TaxAmount?._text || 0
                            ),
                            currencyData[0]?.name
                          )}
                        </div>
                        <div>--</div>
                        <div className="bdrs"></div>
                        <h6>
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(
                              getInvoiceId?.invoice?.Invoice?.LegalMonetaryTotal
                                ?.TaxInclusiveAmount?._text || 0
                            ),
                            currencyData[0]?.name
                          )}
                        </h6>
                        <div>
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(
                              getInvoiceId?.invoice?.Invoice?.LegalMonetaryTotal
                                ?.PrepaidAmount?._text || 0
                            ),
                            currencyData[0]?.name
                          )}
                        </div>
                        <div className="bdrs"></div>
                        <h6>
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(
                              getInvoiceId?.invoice?.Invoice?.LegalMonetaryTotal
                                ?.PayableAmount?._text || 0
                            ),
                            currencyData[0]?.name
                          )}
                        </h6>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <button
              onClick={showToggle}
              className={`commonButton ${showhide}`}
              style={{ marginTop: "20px" }}
            >
              <span className="show1">
                {t("Show More")} <i className="fa-solid fa-angle-right"></i>
              </span>
              <span className="show2">
                {t("Show Less")} <i className="fa-solid fa-angle-down"></i>
              </span>
            </button>

            <div className={`showhidefield ${showhide}`}>
              {/* {isShow && <div>This is the content inside the toggled div.</div>} */}
              <div className="row mb-2">
                <div className="col-md-6">
                  <h6>{t("Delivery Place")}</h6>
                  <div className="paymentInfo">
                    <div className="accincl">
                      {
                        getInvoiceId?.invoice?.Invoice?.AccountingCustomerParty
                          ?.Party?.PostalAddress?.StreetName?._text
                      }
                      <br />
                      {
                        getInvoiceId?.invoice?.Invoice?.AccountingCustomerParty
                          ?.Party?.PostalAddress?.CityName?._text
                      }
                      <br />
                      {
                        getInvoiceId?.invoice?.Invoice?.AccountingCustomerParty
                          ?.Party?.PostalAddress?.PostalZone?._text
                      }
                      <br />
                      {
                        getInvoiceId?.invoice?.Invoice?.AccountingCustomerParty
                          ?.Party?.PostalAddress?.Country?.IdentificationCode
                          ?._text
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-6">&nbsp;</div>
              </div>
              <div className="row mb-2">
                <div className="col-md-6">
                  <h6>{t("Vendor detailed information")}</h6>
                  <div className="paymentInfo">
                    <div className="accInf">
                      <div className="accInfinn">
                        <div className="accincl">{t("E-mail")}</div>
                        <div className="accincl">-&nbsp;</div>
                        <div className="accincl">
                          <span>
                            {
                              getInvoiceId?.invoice?.Invoice
                                ?.AccountingSupplierParty?.Party?.Contact
                                ?.ElectronicMail?._text
                            }
                          </span>
                        </div>
                      </div>
                      <div className="accInfinn">
                        <div className="accincl">{t("Simi")}</div>
                        <div className="accincl">-&nbsp;</div>
                        <div className="accincl">
                          <span>
                            {
                              getInvoiceId?.invoice?.Invoice
                                ?.AccountingSupplierParty?.Party?.Contact
                                ?.Telephone?._text
                            }
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <h6>{t("Purchaser detailed information")}</h6>
                  <div className="paymentInfo">
                    <div className="accInf">
                      <div className="accInfinn">
                        <div className="accincl">{t("Customer number")}</div>
                        <div className="accincl">-&nbsp;</div>
                        <div className="accincl">
                          <span>
                            {
                              getInvoiceId?.invoice?.Invoice
                                ?.AccountingCustomerParty?.Party
                                ?.PartyLegalEntity?.CompanyID?._text
                            }
                          </span>
                        </div>
                      </div>
                      <div className="accInfinn">
                        <div className="accincl">
                          {t("Electronic mail address")}
                        </div>
                        <div className="accincl">-&nbsp;</div>
                        <div className="accincl">
                          <span>---</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <h6>{t("Detailed information per lines")}</h6>
              <div className="tableScroll mb-5">
                <table className="dipl">
                  <tr>
                    <th>{t("Vendor product no")}</th>
                    <th>{t("Standard product no")}</th>
                    <th>{t("Classification")}</th>
                    <th>{t("Accounting information")}</th>
                    <th>{t("Order")}</th>
                    <th>{t("Order line")}</th>
                  </tr>
                  {Array.isArray(getInvoiceId?.invoice?.Invoice?.InvoiceLine) &&
                    getInvoiceId?.invoice?.Invoice?.InvoiceLine?.map((d) => (
                      <tr key={d?.Item?.SellersItemIdentification?.ID?._text}>
                        <td colSpan="6">
                          {d?.Item?.SellersItemIdentification?.ID?._text}
                        </td>
                      </tr>
                    ))}
                  {!Array.isArray(
                    getInvoiceId?.invoice?.Invoice?.InvoiceLine
                  ) &&
                    [getInvoiceId?.invoice?.Invoice?.InvoiceLine]?.map((d) => (
                      <tr key={d?.Item?.SellersItemIdentification?.ID?._text}>
                        <td colSpan="6">
                          {d?.Item?.SellersItemIdentification?.ID?._text}
                        </td>
                      </tr>
                    ))}
                </table>
              </div>

              <h6>
                {t("Detailed information about discount or fees on unit price")}
              </h6>
              <div className="tableScroll">
                <table className="dipl">
                  <tr>
                    <th>{t("Line no.")}</th>
                    <th>{t("Explanation")}</th>
                    <th>{t("Type")}</th>
                    <th>{t("List Price")}</th>
                    <th>{t("Percentage")}</th>
                    <th>{t("Amount")}</th>
                    <th>{t("Unit price")}</th>
                  </tr>
                  <tr>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                </table>
              </div>
              <small>
                {t(
                  "Notice, unit price is displayed with regards to discount, fees and without VAT"
                )}
              </small>

              <h6 className="mt-3">{t("documents")}</h6>
              <div className="tableScroll mb-5">
                <table className="dipl">
                  <tr>
                    <th>{t("No.")}</th>
                    <th>{t("Type")}</th>
                    <th>{t("Reference")}</th>
                  </tr>
                  <tr>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoicedetails;
